import Loading from "./loading"
import ScrollToModule from "./scrollToModule"
export default {
    install (Vue) {
        Vue.directive('imloading', Loading)
        Vue.directive('scroll-to-module', ScrollToModule)
    }
}